<template>
  <div class="uk-child-width-expand uk-grid-small" uk-grid>
    <div v-for="item in rowContent">
      <card :item="item"></card>
    </div>
  </div>
</template>

<script>
  import card from './category-card'
  export default {
    name: 'short-category-content-row',
    props: ['content', 'screenWidth'],
    components: {
      card
    },
    data () {
      return {
        placeholder: '/static/custom-icons/search-error-image.svg'
      }
    },
    computed: {
      rowContent() {
        if (this.screenWidth <= 1024) {
          return this.content.slice(0, 2)
        } else {
          return this.content
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  @import '../../../styles/colours';

  .uk-card-body {
    padding: 0;
  }
  .uk-first-column {
    padding: 0;
  }

</style>
